import React from 'react'
import DashboardHeader from '../Integration/DashboardHeader'
import SuplierDash from '../Integration/SuplierDash'
import FormSupplierVendas from '../Integration/FormSupplierVendas'
import FbBusinessVendas from '../../Middleware/Firebase/FbBusinessVendas'

function PageSupplierVendas() {
  return (
    <div>
<DashboardHeader/>
<SuplierDash/>
<FbBusinessVendas/>

    </div>
  )
}

export default PageSupplierVendas